import type { StaffAttendanceStatus } from '../types/hrmsAttendanceRecords.types'

interface AttendanceRecordStatusBadgeProps {
  status: StaffAttendanceStatus
}

export function AttendanceRecordStatusBadge({ status }: AttendanceRecordStatusBadgeProps) {
  switch (status) {
    case 'Present':
      return (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-700 border border-emerald-200 whitespace-nowrap">
          <span className="h-1.5 w-1.5 rounded-full bg-emerald-500 shrink-0" />
          Present
        </span>
      )
    case 'Late':
      return (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-amber-50 px-2.5 py-1 text-xs font-semibold text-amber-700 border border-amber-200 whitespace-nowrap">
          <span className="h-1.5 w-1.5 rounded-full bg-amber-500 shrink-0" />
          Late
        </span>
      )
    case 'Absent':
      return (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-red-50 px-2.5 py-1 text-xs font-semibold text-red-700 border border-red-200 whitespace-nowrap">
          <span className="h-1.5 w-1.5 rounded-full bg-red-500 shrink-0" />
          Absent
        </span>
      )
    case 'On Leave':
      return (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-slate-100 px-2.5 py-1 text-xs font-semibold text-slate-700 border border-slate-200">
          <span className="h-1.5 w-1.5 rounded-full bg-slate-400 shrink-0" />
          On Leave
        </span>
      )
    case 'Half Day':
      return (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-sky-50 px-2.5 py-1 text-xs font-semibold text-sky-700 border border-sky-200 whitespace-nowrap">
          <span className="h-1.5 w-1.5 rounded-full bg-sky-500 shrink-0" />
          Half Day
        </span>
      )
    default:
      return null
  }
}
